import React, { useState } from 'react'
import styledComponents from '../../styles/IntroContainer-style.js'
import LogoHeader from '../LogoHeader'
import InfoContainer from '../InfoContainer'
import MapGL from "react-map-gl";
import WaveContainer from '../Wave2/canvas';

const { Container, Background, MapContainer, HeaderContainer, MenuContainer } = styledComponents;

const MAPBOX_TOKEN = "pk.eyJ1IjoiaHl1bm1pbiIsImEiOiJja3JrZzh2N2QyMGp5MzFvMmlhOHZyZWJqIn0.BZro_OCBGxLy7n7Sbxz95w";

const IntroContainer = () => {
    const [viewport, setViewport] = useState({
        latitude: 37.402142,
        longitude: 125.100616,
        zoom: 6
    });
    return (
        <Container>
            <Background >
                <WaveContainer />
            </Background >
            <MapContainer>
                <MapGL
                    {...viewport}
                    width="100%"
                    height="100%"
                    mapStyle="mapbox://styles/hyunmin/ckuf8nkw0beut18npgk973oa5"
                    mapboxApiAccessToken={MAPBOX_TOKEN}
                    onViewportChange={setViewport}
                    attributionControl={false}
                />
            </MapContainer>
            <HeaderContainer>
                <LogoHeader />
            </HeaderContainer>

            <MenuContainer>
                <InfoContainer />
            </MenuContainer>
        </Container>
    )
}

export default IntroContainer;